module.exports = __webpack_public_path__ + "img/event2412_2.88b06e91.png";